module.exports = __webpack_public_path__ + "static/media/german_pontoon_bridge.94e85a22.png";